
(() => {
  'use strict';

  const models = {
    'Colt': ['1911, 5 Zoll'],
    'Magnum Research / IMI': ['Desert Eagle Mk. XIX'],
    'Glock': [
      '17 / 22 / 31',
      '19 / 23 / 32',
      '21',
      '48'
    ],
    'Heckler & Koch': [
      'P30',
      'USP',
      'SFP9 / VP9'
    ],
    'SIG Sauer': ['P226 MK25'],
    'Smith & Wesson': [
      'Modell 19',
      'Modell 29',
      'Modell 629',
      'Modell 686'
    ],
    'Walther': ['PPK', 'PPQ', 'PDP Compact'],
    'Weihrauch': [
      'HW 3',
      'HW 5',
      'HW357 Hunter'
    ]
  };

  const builds = {
    Kydex: [
      { value: 'taco', label: 'Taco (einteilig)' },
      { value: 'pancake', label: 'Pancake (zweiteilig)' }
    ],
    Leder: [
      { value: 'koecher', label: 'Köcher (einteilig)' },
      { value: 'sattel', label: 'Sattel (zweiteilig)' }
    ]
  };

  const colors = {
    Kydex: [
      'Schwarz',
      'Olive Drab',
      'Orange',
      'Coyote',
      'Andere Farbe – siehe Sonderwünsche'
    ],
    Leder: [
      'Schwarz',
      'Mittelbraun',
      'Dunkelbraun'
    ]
  };

  const mountOptions = {
    taco: [
      'none',
      'fomi',
      'dcc',
      'multi',
      'paddle',
      'other'
    ],
    pancake: [
      'none',
      'speed',
      'wings',
      'drop',
      'other'
    ],
    koecher: [
      'leatherFixed',
      'fomi',
      'dcc',
      'multi',
      'paddle',
      'other'
    ],
    sattel: [
      'leatherFixed',
      'speed',
      'wings',
      'drop',
      'other'
    ]
  };

  const lockOptions = {
    taco: ['noLock', 'tegris', 'hood'],
    pancake: ['noLock', 'tegris', 'hood'],
    koecher: ['noLock', 'daumen'],
    sattel: ['noLock', 'daumen']
  };

  const accessories = {
    none: {
      label: 'Ohne Befestigung',
      cents: 0,
      dataset: null
    },
    leatherFixed: {
      label: 'Feste Lederschlaufe (inklusive)',
      cents: 0,
      dataset: null
    },
    fomi: {
      label: 'FOMI-Clip',
      cents: 850,
      dataset: 'flFomi'
    },
    dcc: {
      label: 'DCC Monoblock',
      cents: 1500,
      dataset: 'flDcc'
    },
    multi: {
      label: 'HS Multi-Lok',
      cents: 1950,
      dataset: 'flMulti'
    },
    paddle: {
      label: 'G-Code GCA11 Paddle',
      cents: 2450,
      dataset: 'flPaddle'
    },
    speed: {
      label: 'SpeedEase Clips (Paar)',
      cents: 1500,
      dataset: 'flSpeed'
    },
    wings: {
      label: 'MM Wings (Paar)',
      cents: 1000,
      dataset: 'flWings'
    },
    drop: {
      label: 'Drop Style Clips (Paar)',
      cents: 1500,
      dataset: 'flDrop'
    },
    other: {
      label: 'Andere Befestigung – siehe Sonderwünsche',
      cents: 0,
      dataset: null
    },
    noLock: {
      label: 'Keine',
      cents: 0,
      dataset: null
    },
    tegris: {
      label: 'Tegris Thumb Break (Level II)',
      cents: 1500,
      dataset: 'flTegris'
    },
    hood: {
      label: 'Hood Kit TRS / Speed Lock (Level II)',
      cents: 3500,
      dataset: 'flHood'
    },
    daumen: {
      label: 'Daumenlasche Lederholster (Level II)',
      cents: 1000,
      dataset: 'flDaumen'
    }
  };

  const money = cents =>
    (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';

  const validId = id =>
    typeof id === 'string' && /^[0-9]+$/.test(id);

  function fillSelect(select, entries, placeholder) {
    select.replaceChildren(new Option(placeholder, ''));

    entries.forEach(entry => {
      if (typeof entry === 'string') {
        select.add(new Option(entry, entry));
      } else {
        select.add(new Option(entry.label, entry.value));
      }
    });

    select.value = '';
    select.disabled = entries.length === 0;
  }

  function initialize(root) {
    if (root.dataset.flExternalInitialized === 'yes') return;

    const find = selector => root.querySelector(selector);

    const material = find('[data-fl-material]');
    const build = find('[data-fl-build]');
    const maker = find('[data-fl-maker]');
    const model = find('[data-fl-model]');
    const barrel = find('[data-fl-barrel]');
    const barrelWrap = find('[data-fl-barrel-wrap]');
    const hand = find('[data-fl-hand]');
    const cant = find('[data-fl-cant]');
    const color = find('[data-fl-color]');
    const stitch = find('[data-fl-stitch]');
    const stitchWrap = find('[data-fl-stitch-wrap]');
    const mount = find('[data-fl-mount]');
    const lock = find('[data-fl-lock]');
    const notes = find('[data-fl-notes]');
    const price = find('[data-fl-price]');
    const message = find('[data-fl-message]');
    const variantList = find('[data-fl-variants]');

    const fields = [
      material, build, maker, model, barrel,
      barrelWrap, hand, cant, color, stitch, stitchWrap,
      mount, lock, notes, price, message,
      variantList
    ];

    if (fields.some(field => !field)) return;

    const sectionId = root.id.replace('fl-konfigurator-', '');

    const form = document.getElementById(
      'product-form-' + sectionId
    );

    const button = document.getElementById(
      'ProductSubmitButton-' + sectionId
    );

    if (!form || !button) return;

    const variants = Array.from(variantList.options).map(option => ({
      id: option.value,
      title: option.textContent.trim(),
      price: Number(option.dataset.price),
      available: option.dataset.available === 'true'
    }));

    function variantForBuild(key) {
      const materialName =
        key === 'taco' || key === 'pancake'
          ? 'Kydex'
          : 'Leder';

      const buildName = {
        taco: 'Taco',
        pancake: 'Pancake',
        koecher: 'Köcher',
        sattel: 'Sattel'
      }[key];

      if (!buildName) return null;

      const matches = variants.filter(variant => {
        const title = variant.title.toLowerCase();

        return (
          title.includes(materialName.toLowerCase()) &&
          title.includes(buildName.toLowerCase())
        );
      });

      return matches.length === 1 ? matches[0] : null;
    }

    let busy = false;

    function barrelRequired() {
      return maker.value === 'Smith & Wesson' ||
             maker.value === 'Magnum Research / IMI';
    }

    function selectedAccessories() {
      return [mount.value, lock.value]
        .filter(Boolean)
        .map(key => accessories[key])
        .filter(Boolean);
    }

    function accessoryIds() {
      return selectedAccessories()
        .filter(item => item.dataset)
        .map(item => root.dataset[item.dataset] || '');
    }

    function accessoryIdsReady() {
      return selectedAccessories()
        .every(item => {
          if (!item.dataset) return true;
          return validId(root.dataset[item.dataset]);
        });
    }

    function configurationComplete() {
      const leather = material.value === 'Leder';

      const specialChoice =
        mount.value === 'other' ||
        color.value.startsWith('Andere');

      const allowedBuild =
        (builds[material.value] || [])
          .some(item => item.value === build.value);

      const allowedMount =
        (mountOptions[build.value] || [])
          .includes(mount.value);

      const allowedLock =
        (lockOptions[build.value] || [])
          .includes(lock.value);

      const allowedColor =
        (colors[material.value] || [])
          .includes(color.value);

      return Boolean(
        material.value &&
        allowedBuild &&
        maker.value &&
        (models[maker.value] || []).includes(model.value) &&
        hand.value &&
        ['Keine', '15°'].includes(cant.value) &&
        allowedColor &&
        allowedMount &&
        allowedLock &&
        (!leather || ['Weiß', 'Anthrazit'].includes(stitch.value)) &&
        (!barrelRequired() || barrel.value.trim()) &&
        (!specialChoice || notes.value.trim())
      );
    }

    function update() {
      const variant = variantForBuild(build.value);
      const complete = configurationComplete();

      const addons = selectedAccessories();

      const addonTotal = addons.reduce(
        (sum, item) => sum + item.cents,
        0
      );

      const basePrice =
        variant && Number.isFinite(variant.price)
          ? variant.price
          : null;

      if (basePrice !== null) {
        price.textContent =
          (complete ? '' : 'ab ') +
          money(basePrice + addonTotal);
      } else {
        price.textContent =
          'Bitte Material und Bauart auswählen';
      }

      const ready = Boolean(
        variant &&
        validId(variant.id) &&
        variant.available &&
        accessoryIdsReady()
      );

      root.dataset.complete = String(complete);

      button.disabled = busy || !complete || !ready;

      if (busy) {
        message.textContent =
          'Konfiguration wird zum Warenkorb hinzugefügt.';
      } else if (!complete) {
        message.textContent =
          'Bitte alle Pflichtfelder auswählen. ' +
          'Sonderauswahlen im Kommentarfeld beschreiben.';
      } else if (!variant) {
        message.textContent =
          'Shopify-Variante konnte nicht eindeutig zugeordnet werden.';
      } else if (!variant.available) {
        message.textContent =
          'Diese Holstervariante ist derzeit nicht verfügbar.';
      } else if (!accessoryIdsReady()) {
        message.textContent =
          'Zubehörartikel konnte nicht zugeordnet werden.';
      } else {
        message.textContent =
          'Auswahl vollständig. ' +
          'Die Konfiguration kann in den Warenkorb gelegt werden.';
      }
    }

    function updateMaterial() {
      fillSelect(
        build,
        builds[material.value] || [],
        material.value
          ? 'Bitte auswählen'
          : 'Zuerst Material auswählen'
      );

      fillSelect(
        color,
        colors[material.value] || [],
        material.value
          ? 'Bitte auswählen'
          : 'Zuerst Material auswählen'
      );

      const leather = material.value === 'Leder';

      stitchWrap.hidden = !leather;
      stitch.required = leather;
      stitch.disabled = !leather;
      stitch.value = '';

      updateBuild();
    }

    function updateBuild() {
      const key = build.value;

      function accessoryEntries(keys) {
        return keys.map(accessoryKey => {
          const item = accessories[accessoryKey];

          return {
            value: accessoryKey,
            label: item.label +
              (item.cents > 0
                ? ' (+' + money(item.cents) + ')'
                : '')
          };
        });
      }

      fillSelect(
        mount,
        accessoryEntries(mountOptions[key] || []),
        key
          ? 'Bitte auswählen'
          : 'Zuerst Bauart auswählen'
      );

      fillSelect(
        lock,
        accessoryEntries(lockOptions[key] || []),
        key
          ? 'Bitte auswählen'
          : 'Zuerst Bauart auswählen'
      );

      update();
    }

    function updateModels() {
      const selectedMaker = maker.value;

      fillSelect(
        model,
        models[selectedMaker] || [],
        selectedMaker
          ? 'Bitte auswählen'
          : 'Zuerst Hersteller auswählen'
      );

      barrel.value = '';

      const required = barrelRequired();

      barrelWrap.hidden = !required;
      barrel.required = required;
      barrel.disabled = !required;

      update();
    }

    function getProperties() {
      const properties = {
        'Material': material.value,
        'Waffenhersteller': maker.value,
        'Waffenmodell': model.value,
        'Händigkeit': hand.value,
        'Vorneigung': cant.value,
        'Farbe': color.value,
        'Befestigung': accessories[mount.value].label,
        'Sicherung': accessories[lock.value].label
      };

      if (material.value === 'Leder') {
        properties['Nahtfarbe'] = stitch.value;
      }

      if (barrelRequired()) {
        properties['Lauflänge in Zoll'] =
          barrel.value.trim();
      }

      if (notes.value.trim()) {
        properties['Sonderwünsche'] =
          notes.value.trim();
      }

      return properties;
    }

    async function addToCart(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (busy) return;

      update();

      const variant = variantForBuild(build.value);

      if (
        !configurationComplete() ||
        !variant ||
        !variant.available ||
        !validId(variant.id) ||
        !accessoryIdsReady()
      ) {
        update();
        return;
      }

      busy = true;
      update();

      const groupId =
        'FL-' +
        Date.now().toString(36) +
        '-' +
        Math.random().toString(36).slice(2, 10);

      // Holster zuerst, danach das zugehörige Zubehör.
      const items = [{
        id: variant.id,
        quantity: 1,
        properties: {
          ...getProperties(),
          '_fl_group': groupId,
          '_fl_role': 'holster'
        }
      }];

      accessoryIds().forEach(id => {
        items.push({
          id,
          quantity: 1,
          properties: {
            '_fl_group': groupId,
            '_fl_role': 'zubehoer'
          }
        });
      });

      try {
        const rootUrl =
          window.Shopify?.routes?.root || '/';

        const response = await fetch(
          rootUrl + 'cart/add.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Shopify konnte die Artikel nicht hinzufügen.'
          );
        }

        window.location.assign(rootUrl + 'cart');

      } catch (error) {
        busy = false;
        update();

        message.textContent =
          'Warenkorbfehler: ' + error.message;

        console.error(
          'Flachlandholster Warenkorb:',
          error
        );
      }
    }

    material.addEventListener('change', updateMaterial);
    build.addEventListener('change', updateBuild);
    maker.addEventListener('change', updateModels);

    [
      model, hand, cant, color, stitch, mount, lock
    ].forEach(element => {
      element.addEventListener('change', update);
    });

    barrel.addEventListener('input', update);
    notes.addEventListener('input', update);

    form.addEventListener('submit', addToCart, true);

    root.dataset.flExternalInitialized = 'yes';

    updateMaterial();
    updateModels();
  }

  function initializeAll() {
    document
      .querySelectorAll('[data-fl-config]')
      .forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeAll
  );
})();
